import { Box, Stack, Typography } from "@mui/material";
import ButtonComponent from '../../components/form/buttonComponent';

const ErrorView = ({
    icon=null, 
    errorTitle="",
    errorDescription="",
    actionTxt="",
    height="100vh",
    action=null
}) => {
    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                width='100%'
                height={height}
                spacing={2}
            >
                {/* Icon */}
                {
                    icon
                    ?
                    <Box
                        width={{xs: 200, md: 300}}
                    >
                        <img 
                            src={icon} 
                            alt="error" 
                            width='100%'
                        />
                    </Box>
                    :
                    <></>
                }

                {/* Title */}
                <Typography
                    color="black"
                    fontWeight={700}
                    fontSize={{xs: 20, md: 24, lg: 32}}
                    textAlign='center'
                    lineHeight={1.25}
                    width='90%'
                >
                    {errorTitle}
                </Typography>

                {/* Description */}
                <Typography
                    color="#222222"
                    fontWeight={300}
                    fontSize={{xs: 14, md: 14, lg: 14}}
                    textAlign='center'
                    lineHeight={1.5}
                    width={{xs: '90%', md: '75%', lg: '50%'}}
                >
                    {errorDescription}
                </Typography>

                {/* Action */}
                {
                    action
                    ?
                    <Box 
                        pt={5} 
                    >
                        <ButtonComponent 
                            label={actionTxt}
                            onClick={action}
                        />
                    </Box>
                    :
                    <></>
                }
            </Stack>
        </>
    );
}

export default ErrorView;